<template>
  <div class="main">
    <div class="card-info">
      <div style="border-bottom: 1px solid #d2d2d2;padding-bottom: 12px;">拼车信息</div>
      <div style="border-bottom: 1px dashed #D2D2D2;padding: 12px 0;">
        <div class="cell-flex">
          <div style="min-width: 70px;">时间</div>
          <div style="color: #F22222;">{{form.DepartTime}}</div>
        </div>
        <div class="cell-flex cell-way">
          <div style="min-width: 70px;">途径</div>
          <div>{{form.Way}}</div>
        </div>
      </div>
      <div class="cell-flex" style="padding: 12px 0;">
        <van-image width="20" height="20" :src="require('../../assets/img2.svg')"/>
        <div class="carperson">已拼{{passengerList.length}}人</div>
      </div>
      <div v-for="(item, key) in passengerList" :key="key" class="passenger-card">
        <div style="display: flex;justify-content: space-between;">
          <div class="cell-flex"> 
            <div style="width: 70px;">{{item.Name}}</div>
            <div>{{item.Phone}}</div>
          </div>
          <div><van-icon name="clock" size="14" color="#C9C9C9"/> 18:30拼车</div>
        </div>
      </div>
    </div>
    <div style="margin: 0 12px;">
      <baidu-map>
        <!-- <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation> -->
        <bm-view class="map"></bm-view>
        <bm-driving
          location="珠海"
          :start="form.LngLat.length ? form.LngLat[0] : WXInfo.area === '健树' ? {lat: 21.976413, lng: 113.240499} : { lat:22.396843, lng:113.555596 }"
          :end="endLngLat"
          startCity="珠海"
          endCity="珠海"
          :auto-viewport="true"
          :panel="false"
          :waypoints="way"
        >
        </bm-driving>
      </baidu-map>
    </div>
    <div style="height:150px;"></div>
    <div class="bottom-box">
      <div class="driver-info">
        <div class="cell-flex">
          <van-image round width="34px" height="34px" :src="form.Avatar" />
          <div style="padding-left: 12px;">
            <div>{{form.Name}} {{form.CarNum}}</div>
            <div>
              <a>({{form.CarName}} | {{form.CarSeat}}座)</a>
            </div>
          </div>
        </div>
        <a style="text-align: center;color: black;" :href="'tel://' + form.Phone">
          <van-icon name="phone" color="#FEB013" size="24"/>
          <div style="font-size: 13px;">联系司机</div>
        </a>
      </div>
      <van-button block round color="#FEB013" @click="onSubmit" :disabled="BindBtn">绑定司机</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        WXInfo: {},
        form: {
          LngLat: []
        },
        passengerList: [],
        BindBtn: false,
        way: [],
        endLngLat: {}
    }
  },
  async mounted() {
    // const test = {"errno":0,"data":{"area":"健树","errcode":0,"errmsg":"ok","userid":"201755101","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"o_Td1s7gCLuLiZITNxC3ApjOLC7U","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
    // this.WXInfo = test.data
    this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
    this.form.Name = this.WXInfo.name
    this.form.UserId = this.WXInfo.userid
    this.form.Phone = this.WXInfo.mobile
    this.endLngLat = this.WXInfo.area === '健树' ? {lat: 21.976413, lng: 113.240499} : { lat:22.396843, lng:113.555596 }
    await this.getWorkDriverInfo()
    this.getPassengerList()
  },
  methods: {
    onSubmit() {
      this.BindBtn = true
      this.$router.push('/work/apply?workrole=passenger&driverid=' + this.$route.query.id)
    },
    async getWorkDriverInfo() {
      const result = await this.$request({
        url: this.$api.getWorkDriverList,
        method: 'GET',
        params: {
          UserId: this.$route.query.id,
          Role: 'driver',
          Effictive: true,
          Status: true
        }
      })
      if (result.data.length) {
        this.form = result.data[0]
        this.way = JSON.parse(JSON.stringify(result.data[0].LngLat))
        this.way.splice(0,1)
      }
    },
    // 获取已绑定的乘客列表
    async getPassengerList() {
      const result = await this.$request({
        url: this.$api.getPassengerListByDriverId,
        method: 'GET',
        params: {
          DriverId: this.$route.query.id,
          Effictive: true,
          Status: true
        }
      })
      if (result.data.length > 0) {
        this.passengerList = result.data
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .main {
    overflow: hidden;
  }
  .map {
    width: 100%;
    height: 250px;
    border-radius: 4px;
  }
  .card-info {
    background-color: #FFFFFF;
    border-radius: 4px;
    margin: 12px;
    padding: 12px;
  }
  .cell-flex {
    display: flex;
    align-items: center;
  }
  .cell-way {
    min-height: 40px;
    align-items: baseline;
    padding-top: 8px;
  }
  .passenger-card {
    background-color: #F9F9F9;
    border-radius: 4px;
    padding: 2px 12px;
    font-size: 14px;
  }
  .bottom-box {
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 8px 8px 0px 0px;
    padding: 12px 24px 24px 24px;
  } 
  .driver-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }
  .carperson {
    padding-left: 4px;
    color: red;
  }
</style>
